/**
 * Styles for wf-back-btn component (Shadow DOM)
 */

import { css } from 'lit';

import { buttonBaseStyles } from '../styles/shared.styles.js';

export const wfBackBtnStyles = [
  buttonBaseStyles,
  css`
    :host {
      display: inline-block;
    }

    :host([hidden]) {
      display: none;
    }

    .wf-btn-back {
      background: var(--wf-glass-bg);
      backdrop-filter: blur(var(--wf-glass-blur));
      -webkit-backdrop-filter: blur(var(--wf-glass-blur));
      border: 1px solid var(--wf-glass-border);
      box-shadow: var(--wf-glass-shadow);
      color: var(--wf-color-text);
    }

    .wf-btn-back:hover:not(:disabled) {
      background: var(--wf-glass-bg-hover);
    }

    .wf-btn-shortcut {
      display: inline-flex;
      align-items: center;
      gap: var(--wf-spacing-05);
    }
  `,
];
